import React, { useEffect, useState } from 'react';

const RatesTable = () => {
  const [rates, setRates] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'rate', direction: 'descending' });
  const apiUrl = 'https://api.sheety.co/8665b8fb05801f2a465ec0b3b8dcdc28/bestRate/bank';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await response.json();
        setRates(data.bank || []);
      } catch (error) {
        console.error('Error fetching data:', error);
        setRates([]);
      }
    };

    fetchData();
  }, []);

  const formatRate = (rate) => `${(parseFloat(rate) * 100).toFixed(2)}%`;
  const formatBalance = (balance) =>
    balance === '∞' ? 'No Limit' : `$${parseFloat(balance || 0).toLocaleString()}`;

  const sortedRates = [...rates].sort((a, b) => {
    const valueA = a[sortConfig.key] || '';
    const valueB = b[sortConfig.key] || '';

    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return sortConfig.direction === 'ascending'
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }

    return sortConfig.direction === 'ascending' ? valueA - valueB : valueB - valueA;
  });

  const handleSort = (key) => {
    setSortConfig((prevConfig) => {
      const isSameColumn = prevConfig.key === key;
      const newDirection = isSameColumn && prevConfig.direction === 'ascending' ? 'descending' : 'ascending';
      return { key, direction: newDirection };
    });
  };

  return (
    <div className="rates-section">
      <h2>No BS. Just The Best Checking and Saving Account Rates on {new Date().toLocaleDateString()}</h2>
      <table className="rates-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('bank')}>Bank</th>
            <th onClick={() => handleSort('rate')}>% Rate</th>
            <th onClick={() => handleSort('eligability')}>Eligibility</th>
            <th onClick={() => handleSort('balance')}>Balance</th>
            <th onClick={() => handleSort('requirements')}>Requirements</th>
            <th onClick={() => handleSort('benefits')}>Benefits</th>
            <th onClick={() => handleSort('other')}>Other</th>
          </tr>
        </thead>
        <tbody>
          {sortedRates.length > 0 ? (
            sortedRates.map((rate, index) => (
              <tr key={index}>
                <td>
                  {rate.bankUrl ? (
                    <a href={rate.bankUrl} target="_blank" rel="noopener noreferrer">
                      {rate.bank || 'Learn More'}
                    </a>
                  ) : (
                    rate.bank || 'N/A'
                  )}
                </td>
                <td>{formatRate(rate.rate || 0)}</td>
                <td>
                  {rate.requirementsUrl ? (
                    <a href={rate.requirementsUrl} target="_blank" rel="noopener noreferrer">
                      {rate.eligability || 'Learn More'}
                    </a>
                  ) : (
                    rate.eligability || 'N/A'
                  )}
                </td>
                <td>{formatBalance(rate.balance)}</td>
                <td>{rate.requirements || 'N/A'}</td>
                <td>{rate.benefits || 'N/A'}</td>
                <td>{rate.other || 'N/A'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">Loading...</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RatesTable;
